<div class="purchase-container">
  <div class="glow green"></div>
  <div class="glow purple"></div>
  <h1>Purchase Game Points</h1>
  <p class="subtitle">Power up your gaming experience with additional points</p>

  <app-points-list></app-points-list>

  <app-payment-info></app-payment-info>
</div>
